import { Link } from "react-router-dom";
import {
  Snowflake, Flame, Thermometer, LayoutGrid, Fan, Package, Layers, Wind, Wrench, ArrowRight,
} from "lucide-react";
import { categoryAccent } from "@/data/catalog";

const ICONS = { Snowflake, Flame, Thermometer, LayoutGrid, Fan, Package, Layers, Wind, Wrench };

export default function CategoryCard({ category, count }) {
  const Icon = ICONS[category.icon] || Package;
  const warm = categoryAccent(category.slug) === "warm";
  return (
    <Link
      to={`/category/${category.slug}`}
      data-testid={`category-card-${category.slug}`}
      className="group relative flex flex-col overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm transition-[transform,box-shadow,border-color] duration-200 hover:-translate-y-1 hover:border-slate-300 hover:shadow-[0_18px_40px_-22px_rgba(15,23,42,0.4)]"
    >
      <span className={`h-1 w-full ${warm ? "bg-orange-500" : "bg-sky-600"}`} />
      <div className="flex flex-1 flex-col p-5">
        <div className="flex items-start justify-between">
          <span className={`flex h-12 w-12 items-center justify-center rounded-md ${warm ? "bg-orange-50 text-orange-600" : "bg-sky-50 text-sky-700"}`}>
            <Icon className="h-6 w-6" />
          </span>
          {count != null && (
            <span className="rounded-sm bg-slate-100 px-2 py-0.5 font-mono text-[10px] font-semibold text-slate-500">
              {count > 0 ? `${count} ${count === 1 ? "model" : "models"}` : "Coming soon"}
            </span>
          )}
        </div>
        <div className="mt-5">
          <h3 className="font-heading text-base font-bold tracking-tight text-slate-900 sm:text-lg">{category.name}</h3>
          <p className="mt-1 text-sm text-slate-500">{category.blurb}</p>
        </div>
        <span className={`mt-4 inline-flex items-center gap-1 text-xs font-semibold ${warm ? "text-orange-600" : "text-sky-700"}`}>
          Browse <ArrowRight className="h-3.5 w-3.5 transition-transform duration-200 group-hover:translate-x-0.5" />
        </span>
      </div>
    </Link>
  );
}
